export default __webpack_public_path__ + "static/media/FFS.6c37e28c.png";